import {
	ChangeDetectionStrategy,
	Component,
	input,
	output,
} from '@angular/core';

import {
	AvatarStackComponent,
	AvatarStackItem,
} from '@ui/avatar-stack/avatar-stack.component';
import { CardComponent } from '@ui/card/card.component';
import { IconsModule } from '@ui/icons/icons.module';
import { ButtonComponent } from 'src/app/ui/button/button.component';

@Component({
	selector: 'app-e-signing-meta-details',
	standalone: true,
	imports: [CardComponent, AvatarStackComponent, IconsModule, ButtonComponent],
	templateUrl: './e-signing-meta-details.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'w-full' },
})
export class ESigningMetaDetailsComponent {
	public editSigners = output<void>();
	public avatars = input<AvatarStackItem[]>([]);
	public envelopeId_ = input.required<string>();
}
